import { render, staticRenderFns } from "./BillingPeriodSelect.vue?vue&type=template&id=3b5a16e9&scoped=true"
import script from "./BillingPeriodSelect.ts?vue&type=script&lang=ts&external"
export * from "./BillingPeriodSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./BillingPeriodSelect.vue?vue&type=style&index=0&id=3b5a16e9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5a16e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5a16e9')) {
      api.createRecord('3b5a16e9', component.options)
    } else {
      api.reload('3b5a16e9', component.options)
    }
    module.hot.accept("./BillingPeriodSelect.vue?vue&type=template&id=3b5a16e9&scoped=true", function () {
      api.rerender('3b5a16e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Dashboard/components/BillingSection/BillingPeriodSelect/BillingPeriodSelect.vue"
export default component.exports